// @flow

import {
  GetNotificationContacts,
  GetNotificationContactsSuccess,
  GetNotificationContactsError,
  SetNotificationContactsSelectedEmployeeId,
} from "@modules/profile/constants/actions";
import type { MyEmployeesState } from "./types";
import { cloneObject } from "@utils/object";

export const initialState: MyEmployeesState = {
  requestsInProgress: 0,
  error: null,
  list: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
  selectedEmployeeId: null,
};

export const setLoading = (state: MyEmployeesState) => () => {
  return {
    ...state,
    requestsInProgress: ++state.requestsInProgress,
  };
};

export const onGetNotificationContactsSuccess = (state: MyEmployeesState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: null,
    list: payload,
  };
};

export const onGetNotificationContactsError = (state: MyEmployeesState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
    error: payload,
  };
};

export const onSetNotificationContactsSelectedEmployeeId = (state: MyEmployeesState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    selectedEmployeeId: payload,
  };
};

export default (state: MyEmployeesState = initialState, action: Object): MyEmployeesState => {
  const act = {
    [GetNotificationContacts]: setLoading,
    [GetNotificationContactsSuccess]: onGetNotificationContactsSuccess,
    [GetNotificationContactsError]: onGetNotificationContactsError,
    [SetNotificationContactsSelectedEmployeeId]: onSetNotificationContactsSelectedEmployeeId,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
